import { unaVez } from "../eventos";
var acordeon = function (selector, unico) {
    if (unico === void 0) { unico = true; }
    [].forEach.call(document.querySelectorAll(selector), function (contenedor) {
        var botones = [].slice.call(contenedor.querySelectorAll('[aria-controls]')), paneles = botones.map(function (boton) { return document.getElementById(boton.getAttribute('aria-controls')); });
        var abriendo = false;
        paneles.forEach(function (panel) { return panel.style.maxHeight = '0px'; });
        var mostrar = function (panel) {
            return new Promise(function (resolve) {
                panel.hidden = false;
                panel.setAttribute('aria-expanded', 'true');
                botones
                    .filter(function (x) { return x.getAttribute('aria-controls') === panel.id; })
                    .forEach(function (x) { return x.setAttribute('aria-expanded', 'true'); });
                panel.closest('div').classList.add('activo');
                panel.style.maxHeight = '0px';
                requestAnimationFrame(function () {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                    unaVez(panel, 'transitionend', function () {
                        panel.style.maxHeight = 'initial';
                        resolve();
                    });
                });
            });
        };
        var ocultar = function (panel) {
            return new Promise(function (resolve) {
                panel.setAttribute('aria-expanded', 'false');
                botones
                    .filter(function (x) { return x.getAttribute('aria-controls') === panel.id; })
                    .forEach(function (x) { return x.setAttribute('aria-expanded', 'false'); });
                panel.closest('div').classList.remove('activo');
                requestAnimationFrame(function () {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                    requestAnimationFrame(function () {
                        panel.style.maxHeight = '0px';
                        unaVez(panel, 'transitionend', function () {
                            panel.hidden = true;
                            resolve();
                        });
                    });
                });
            });
        };
        var abrePanel = function (posicion) {
            if (abriendo) {
                return;
            }
            if (posicion >= 0) {
                abriendo = true;
                var promesas_1 = [];
                if (paneles[posicion].hidden) {
                    promesas_1.push(mostrar(paneles[posicion]));
                }
                else {
                    promesas_1.push(ocultar(paneles[posicion]));
                }
                if (unico) {
                    paneles
                        .filter(function (panel, i) { return i !== posicion && !panel.hidden; })
                        .forEach(function (panel) { return promesas_1.push(ocultar(panel)); });
                }
                Promise.all(promesas_1).then(function () { return abriendo = false; });
            }
        };
        contenedor.addEventListener('click', function (e) {
            abrePanel(botones.indexOf(e.target));
        }, true);
        contenedor.addEventListener('keydown', function (e) {
            var boton = e.target;
            if (!boton || boton.nodeName !== 'BUTTON') {
                return;
            }
            switch (e.key) {
                case 'Space': {
                    abrePanel(botones.indexOf(boton));
                    break;
                }
                case 'ArrowDown': {
                    var siguiente = (botones.indexOf(boton) + 1) % botones.length;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'ArrowUp': {
                    var posicion_1 = botones.indexOf(boton), siguiente = posicion_1 === 0 ? botones.length - 1 : posicion_1 - 1;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'Home': {
                    botones[0].focus();
                    e.preventDefault();
                    break;
                }
                case 'End': {
                    botones[botones.length - 1].focus();
                    e.preventDefault();
                    break;
                }
            }
        }, true);
    });
};
export default acordeon;
